import './App.css';
import './i18n';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

function Layout({ children }) {
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<div>Loading translations...</div>}>
      <div className='wrapper'>
        {pathname !== "/" ? <Header /> : null}
        <div className='main'>
          {children}
        </div>
        <Footer />
      </div>
    </Suspense>
  );
}

export default Layout ;